import React from 'react';
import { cn } from '../utils';

interface SliderFieldProps {
  label: string;
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  icon?: React.ReactNode;
  color?: 'primary' | 'secondary' | 'accent';
}

export default function SliderField({
  label,
  value,
  onChange,
  min = 0,
  max = 10,
  icon,
  color = 'primary',
}: SliderFieldProps) {
  const colorMap = {
    primary: 'accent-primary text-primary',
    secondary: 'accent-secondary text-secondary',
    accent: 'accent-accent text-accent',
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div
            className={cn(
              'flex h-8 w-8 items-center justify-center rounded-lg bg-slate-50 dark:bg-slate-800',
              colorMap[color].split(' ')[1]
            )}
          >
            {icon}
          </div>
          <span className="text-sm font-extrabold tracking-tight text-slate-700 dark:text-slate-300">
            {label}
          </span>
        </div>
        <span
          className={cn(
            'font-mono text-sm font-black tabular-nums',
            colorMap[color].split(' ')[1]
          )}
        >
          {value}
        </span>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        step={1}
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value))}
        className={cn('w-full', colorMap[color].split(' ')[0])}
      />
    </div>
  );
}
